export const refs = {
  body: document.querySelector('body'),
  homeButton: document.querySelector('#home_btn'),
  logo: document.querySelector('#header-logo'),
  libraryButton: document.querySelector('#library_btn'),
  searchForm: document.querySelector('#search-form'),
  filmGallery: document.querySelector('.gallery__list'),
  filmCardModalWrap: document.querySelector('#filmCardModalWrap'),
  pagination: document.querySelector('#pagination'),
  watched: document.querySelector('#watched'),
  queue: document.querySelector('#queue'),
  spanToggle: document.querySelector('.footer-team-popup'),
  animeEl: document.querySelectorAll('.anime'),
  headerContainer: document.querySelector('#header'),
  homeCurrentPage: document.querySelector('#home-current-page'),
  libraryCurrentPage: document.querySelector('#library-current-page'),
  hederLibraryPage: document.querySelector('#header-library'),
  modalCloseButton: document.querySelector('.modal-close_button'),
  modalCardDetail: document.querySelector('.film-detail-modal'),
  backdrop: document.querySelector('.backdrop'),
  libraryWatchedButton: document.querySelector('#library-watched__button'),
  libraryQueueButton: document.querySelector('#library-queue__button'),
  header: document.querySelector('.page-header'),
  clearLibraryBtn: document.querySelector('.clear-lbr'),
};
